module.exports = __webpack_public_path__ + "static/media/naturalAreasConservancy.09b57062.png";